import {
  Autocomplete,
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Sidebar from "../../../components/sidebar/sidebar";
import { Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { Formik, Form } from "formik";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import {
  fetchCustomerLoanReportService,
  fetchCustomerPigmyReportService,
  fetchCustomerReportService,
} from "../../../services/reportService";
import { getAllAgentsService } from "../../../services/agentService";
import { toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx";

function LoanReport() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loans, setLoans] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [isExcelData, setIsExcelData] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //   const [customer, setcustomer] = useState([]); // Assuming you will fetch the customer
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [agents, setAgents] = useState([]);
  const [totalLoans, setTotalLoans] = useState();
  const initialValues = {
    fromDate: null,
    toDate: null,
    frequency: "",
    status: "",
    agent: "",
    search: "",
  };
  const [filters, setFilters] = useState(initialValues);

  const frequencies = ["daily", "weekly", "monthly"];
  const statuses = ["Active", "Closed", "Over Due"];

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts);
    } catch (err) {
      toast.error(err.message);
    }
  };

  //   const handleFilter = () => {
  //     fetchPigmy();
  //     // Fetch or filter customer based on fromDate and toDate
  //   };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchPigmy = async (values) => {
    try {
      setLoading(true);
      const getloans = await fetchCustomerLoanReportService(
        values.fromDate, // Formik values now being used
        values.toDate,
        page,
        rowsPerPage,
        values.frequency,
        values.status,
        values.agent,
        isExcelData,
        values.search
      );
      setLoans(getloans?.loans);
      setTotalLoans(getloans?.totalLoans);
      setExcelData(getloans?.excelData); // Adjust this based on API response structure
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const exportToExcel = async () => {
    setExcelLoading(true);
    const getLoans = await fetchCustomerLoanReportService(
      filters.fromDate,
      filters.toDate,
      page,
      rowsPerPage,
      filters.frequency,
      filters.status,
      filters.agent,
      true
    );

    const excelData = getLoans?.excelData || [];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Loan Report");

    // Define columns
    worksheet.columns = [
      { header: "SL.NO", key: "slNo", width: 8 },
      { header: "Agent Name", key: "agentName", width: 20 },
      { header: "Customer Name", key: "customerName", width: 30 },
      { header: "Phone Number", key: "phoneNumber", width: 15 },
      { header: "Loan Code", key: "loanCode", width: 15 },
      { header: "Loan Amount", key: "loanAmount", width: 15 },
      { header: "Frequency", key: "frequency", width: 12 },
      { header: "Loan Tenure", key: "loanTenure", width: 14 },
      { header: "Interest Rate", key: "interest", width: 14 },
      { header: "Disbursed Amount", key: "disbursedAmount", width: 20 },
      { header: "Collection Amount", key: "collectionAmount", width: 20 },
      { header: "Start Date", key: "startDate", width: 15 },
      { header: "End Date", key: "endDate", width: 15 },
      { header: "Status", key: "status", width: 12 },
      {
        header: "Total Received Amount",
        key: "totalReceivedAmount",
        width: 24,
      },
      { header: "Closure", key: "closureDate", width: 15 },
    ];

    // Add rows with styling
    excelData.forEach((loan, index) => {
      const row = worksheet.addRow({
        slNo: index + 1,
        agentName: loan.agent?.userName || "",
        customerName: loan.user?.userName || "",
        phoneNumber: loan.user?.primaryPhone?.contactValue || "",
        loanCode: loan.loanCode || "",
        loanAmount: loan.loanAmount || "",
        frequency: loan.frequency || "",
        loanTenure: loan.loanTenure || "",
        interest: loan.interest || "",
        disbursedAmount: loan.disbursedAmount || "",
        collectionAmount: loan.collectionAmount || "",
        startDate: moment(loan.startDate).format("DD-MM-YYYY"),
        endDate: moment(loan.endDate).format("DD-MM-YYYY"),
        status: loan.status || "",
        totalReceivedAmount: loan.totalReceivedAmount || "",
        closureDate: loan.endDate
          ? moment(loan.endDate).format("DD-MM-YYYY")
          : "N/A",
      });

      // Highlight key cells
      row.getCell("agentName").font = {
        color: { argb: "FF1E88E5" },
        bold: true,
      };
      row.getCell("customerName").font = {
        color: { argb: "FFF57C00" },
        bold: true,
      };
      row.getCell("phoneNumber").font = {
        color: { argb: "FF00897B" },
        bold: true,
      };
      row.getCell("loanAmount").font = {
        color: { argb: "FF388E3C" },
        bold: true,
      };
      row.getCell("collectionAmount").font = {
        color: { argb: "FFD32F2F" },
        bold: true,
      };
      row.getCell("totalReceivedAmount").font = {
        color: { argb: "FFD32F2F" },
        bold: true,
      };
    });

    // Style header
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "5252FF" },
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    // Export
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "LoanReport.xlsx");

    setExcelLoading(false);
  };

  useEffect(() => {
    fetchPigmy(filters);
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchPigmy({});
    fetchAgents();
  }, []);

  return (
    <>
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">Loan Report</Typography>
            </Box>
            <Paper
              style={{
                color: "#000",
                padding: "20px",
                marginTop: 20,
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                // backgroundColor: "#f7f7ff",
              }}
            >
              <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                  setFilters(values);
                  fetchPigmy(values); // Pass Formik values when filtering
                }}
              >
                {({ values, handleChange, setFieldValue }) => (
                  <Form>
                    <Box sx={{ p: 2 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={2}>
                          <Typography>From Date</Typography>
                          <TextField
                            type="date"
                            name="fromDate"
                            size="small"
                            value={values.fromDate}
                            onChange={handleChange}
                            InputLabelProps={{
                              shrink: true, // This ensures that the label doesn't overlap with the value
                            }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <Typography>To Date</Typography>
                          <TextField
                            type="date"
                            name="toDate"
                            size="small"
                            value={values.toDate}
                            onChange={handleChange}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                          />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Frequency</Typography>
                            <Select
                              name="frequency"
                              value={values.frequency}
                              onChange={handleChange}
                              size="small"
                            >
                              {frequencies.map((freq) => (
                                <MenuItem key={freq} value={freq}>
                                  {freq}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Status</Typography>
                            <Select
                              size="small"
                              name="status"
                              value={values.status}
                              onChange={handleChange}
                            >
                              {statuses.map((status) => (
                                <MenuItem key={status} value={status}>
                                  {status}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Agent</Typography>
                            <Select
                              size="small"
                              name="agent"
                              value={values.agent}
                              onChange={handleChange}
                            >
                              {agents.map((agent) => (
                                <MenuItem key={agent._id} value={agent._id}>
                                  {agent.userName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <TextField
                            size="small"
                            label="Search Customer Name"
                            fullWidth
                            onChange={(event) => {
                              setFieldValue("search", event.target.value);
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} textAlign="center">
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<i className="fas fa-filter"></i>}
                          >
                            {loading ? (
                              <CircularProgress
                                size={24}
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              "Generate"
                            )}
                          </Button>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={exportToExcel}
                            startIcon={<i className="fas fa-download"></i>}
                            style={{ marginLeft: 10 }}
                          >
                            {excelLoading ? (
                              <CircularProgress
                                size={24}
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              "Download Excel"
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Paper>
            <Box sx={{ mt: 2 }}></Box>
            <TableContainer>
              <Table
                sx={{
                  minWidth: 650,
                  borderCollapse: "separate",
                  borderSpacing: "0 8px",
                }}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                    {[
                      "SL.NO",
                      "Agent Name",
                      "Customer Name",
                      "Phone Number",
                      "Loan Code",
                      "Loan Amount",
                      "Frequency",
                      "Loan Tenure",
                      "Interest Rate",
                      "Disbursed Amount",
                      "Collection Amount",
                      "Start Date",
                      "End Date",
                      "Status",
                      "Total Received Amount",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          color: "#5252ff",
                          padding: "6px",
                          fontWeight: "bold",
                          borderBottom: "1px solid #e0e0e0",
                          textAlign: "center",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loans?.length > 0 ? (
                    loans?.map((row, index) => {
                      const isClosed = row?.status === "Closed";

                      const isOverdue =
                        row?.status === "Active" &&
                        moment(row?.endDate).isBefore(moment(), "day");
                      return (
                        <TableRow
                          key={row._id}
                          sx={{
                            backgroundColor: isClosed
                              ? "#8B0000" // Closed → Dark Red
                              : isOverdue
                              ? "#FF8C00" // Overdue Active → Dark Orange
                              : index % 2 === 0
                              ? "#fafafa"
                              : "#ffffff",
                            color:
                              isClosed || isOverdue ? "#ffffff" : "inherit",

                            borderRadius: "8px",
                            boxShadow: 1,
                          }}
                        >
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.agent?.userName}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.user?.userName}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.user?.primaryPhone?.contactValue}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.loanCode}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.loanAmount}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.frequency}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.loanTenure}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.interest}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.disbursedAmount}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.collectionAmount}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {moment(row?.startDate).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {moment(row?.endDate).format("DD-MM-YYYY")}
                          </TableCell>

                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.status}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "6px",
                              textAlign: "center",
                              color: isClosed ? "#ffffff" : "inherit",
                            }}
                          >
                            {row?.totalReceivedAmount}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={12}
                        style={{ textAlign: "center", padding: "16px" }}
                      >
                        No Loans available in table
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalLoans}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Show"
            />
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
      </div>
    </>
  );
}

export default LoanReport;
